<template>
<div class="chapter">
<div class="inner_page">
<p class="C242"><strong><a id="page_vii">CONTENTS</a></strong></p><a id="page_vii">
</a><p class="C253"><a id="page_vii"></a><a href="#/html/07_Preface#page_ix">Preface</a></p>
<p class="C253"><a href="#/html/08_1__The_Ironies_of_Affirmative_Ac#page_1"><strong>1.</strong> The Ironies of Affirmative Action</a></p>
<p class="C255"><a href="#/html/09_Part_I__Understanding_Resistance#page_17"><strong>Part I:</strong> Understanding Resistance to Affirmative Action</a></p>
<p class="C255"><a href="#/html/10_2__The_Appeal_of_Color_Blindness#page_19"><strong>2.</strong> The Appeal of Color-Blindness</a></p>
<p class="C253"><a href="#/html/11_3__American_Justice__Acceptable#page_36"><strong>3.</strong> American Justice, Acceptable Preference, and the Boundaries of Legitimate Policymaking</a></p>
<p class="C255"><span href="#/html/12_Part_II__Understanding_Support_f#page_65" title="Link target outside of Sample"><strong>Part II:</strong> Understanding Support for Affirmative Action</span></p>
<p class="C255"><span href="#/html/13_4__Crisis_Management_through_Aff#page_67" title="Link target outside of Sample"><strong>4.</strong> Crisis Management through Affirmative Action</span></p>
<p class="C255"><span href="#/html/14_5__Administrative_Pragmatism_and#page_111" title="Link target outside of Sample"><strong>5.</strong> Administrative Pragmatism and the Affirmative Action Solution</span></p>
<p class="C255"><span href="#/html/15_6__Affirmative_Action_as_Traditi#page_145" title="Link target outside of Sample"><strong>6.</strong> Affirmative Action as Tradition</span></p>
<p class="C255"><span href="#/html/16_7__Creative_Destruction_in_the_N#page_177" title="Link target outside of Sample"><strong>7.</strong> Creative Destruction in the Nixon Administration</span></p>
<p class="C253"><span href="#/html/17_8__Conclusion__Culture__Politics#page_222" title="Link target outside of Sample"><strong>8.</strong> Conclusion: Culture, Politics and Affirmative Action</span></p>
<p class="C255"><span href="#/html/18_Notes#page_243" title="Link target outside of Sample">Notes</span></p>
<p class="C255"><span href="#/html/19_Index#page_295" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_CONTENTS.vue?cadca210